/**
 * @generated SignedSource<<783c0bbefbff506c185d38624b0031ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type genericPostiesArticleContent$data = {
  readonly additionalInfoBoxes: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"articleAdditionalInfoBoxArticle">;
  } | null> | null;
  readonly authors: ReadonlyArray<{
    readonly name: string;
  } | null> | null;
  readonly publishedDate: number | null;
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"articleBaseAdvertisingInfoArticle" | "blockquoteQuoteGenericPostiesArticleContent" | "contentBodyContent" | "genericPostiesArticleVocabBoxArticle">;
  readonly " $fragmentType": "genericPostiesArticleContent";
};
export type genericPostiesArticleContent$key = {
  readonly " $data"?: genericPostiesArticleContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"genericPostiesArticleContent">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "customContents"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "genericPostiesArticleContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegment",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AdditionalInfoBox",
      "kind": "LinkedField",
      "name": "additionalInfoBoxes",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articleAdditionalInfoBoxArticle"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "genericPostiesArticleVocabBoxArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "blockquoteQuoteGenericPostiesArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleBaseAdvertisingInfoArticle"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "customContents",
          "variableName": "customContents"
        }
      ],
      "kind": "FragmentSpread",
      "name": "contentBodyContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "30c91bc5e5a72ac850d808096b87cd09";

export default node;
